// Itens Orçamentários (treinamento turma 5, 20/10): buscar pelo NOME DO GRUPO ("Serviços agência") devolvia só o
// próprio grupo (produto sem superior), e a tela, que monta os grupos a partir dos itens, mostrava a lista vazia.
// Aqui: grupos achados pela busca + os itens deles (vindos da lista completa), sem repetir.

export function gruposAchadosNaBusca(resultado = []) {
    return (Array.isArray(resultado) ? resultado : []).filter((p) => !p.superior).map((p) => String(p.id));
}

export function incluirItensDosGruposAchados(resultado = [], listaCompleta = []) {
    const base = Array.isArray(resultado) ? resultado : [];
    const grupos = gruposAchadosNaBusca(base);
    if (grupos.length === 0) return base;
    const ids = new Set(base.map((p) => String(p.id)));
    const filhos = (Array.isArray(listaCompleta) ? listaCompleta : [])
        .filter((p) => p.superior && grupos.includes(String(p.superior.id)) && !ids.has(String(p.id)));
    return base.concat(filhos);
}
